import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BreadcrumbComponent } from '@core/ui-kit/components';
import { NavbarComponent } from '@shared/components/navbar/navbar.component';
import { PaymentHandlerComponent } from '@shared/components/payment-handler/payment-handler.component';
import { AuthStore } from '@shared/data-access/data-access-authentication';
import { UiStore } from '@shared/data-access/data-access-ui';

@Component({
  selector: 'app-authenticated-layout',
  imports: [RouterOutlet, NavbarComponent, PaymentHandlerComponent, BreadcrumbComponent],
  templateUrl: './authenticated-layout.component.html',
  styleUrl: './authenticated-layout.component.scss',
})
export class AuthenticatedLayoutComponent {
  private readonly uiStore = inject(UiStore);
  private readonly authStore = inject(AuthStore);

  isNavbarExpanded = computed(() => this.uiStore.isNavbarExpanded() && !this.authStore.isAdmin());
}
